
import Vue from 'vue';
import Component from 'vue-class-component';
import LayOut from './nmb/components/layout.vue';

@Component({
  // name: 'app',
  components: { LayOut }
})
export default class App extends Vue {
  get isIE() {
    const userAgent = navigator.userAgent; // 取得浏览器的userAgent字符串
    const isOpera = userAgent.indexOf('Opera') > -1;
    const isIE11 = !!(window as any).ActiveXObject || 'ActiveXObject' in window;
    if (
      (userAgent.indexOf('compatible') > -1 &&
        userAgent.indexOf('MSIE') > -1 &&
        !isOpera) ||
      isIE11 ||
      userAgent.indexOf('Edge') > -1
    ) {
      return true;
    }

    return false;
  }
  // mounted() {
  //   if (this.isIE) {
  //     const h = this.$createElement;
  //     this.$msgbox({
  //       title: '',
  //       message: h(
  //         'div',
  //         { style: 'text-align: center; padding: 30px 50px;' },
  //         [
  //           h(
  //             'h2',
  //             { style: 'color: #F56C6C; margin-bottom: 20px;' },
  //             '兼容性问题提示'
  //           ),
  //           h('p', { style: 'font-size: 18px' }, 'IE浏览器下， '),
  //           h(
  //             'p',
  //             { style: 'font-size: 18px' },
  //             '访问文档中心存在兼容性问题， '
  //           ),
  //           h('p', { style: 'font-size: 18px' }, '建议使用Chrome访问。')
  //         ]
  //       ),
  //       showConfirmButton: true,
  //       confirmButtonClass: 'btn-pass',
  //       confirmButtonText: '不再提示'
  //     });
  //   }
  // }
}
